import { NativeEventSource, EventSourcePolyfill } from 'event-source-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { ConnectedRouter } from 'connected-react-router';

import App from 'App';
import CordovaApp from 'views/pages/Cordova/CordovaApp';

import store from 'configureStore';

import history from 'utils/history';

import { fluentTheme, theme } from 'theme';
import { Capacitor }          from "@capacitor/core";
import { initializeIcons }    from '@uifabric/icons';
import { loadTheme }          from 'office-ui-fabric-react';
import { logDebug }           from './utils/clientLogger';

// @ts-ignore
global.EventSource = NativeEventSource || EventSourcePolyfill;

// @ts-ignore
const isCordovaApp = Capacitor?.isNative;

(window as any).moment = moment;

initializeIcons('/static/fabric-fonts/', { disableWarnings: true });
loadTheme(fluentTheme);
logDebug('Client debug is enabled');

document.addEventListener('deviceready', () => {
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <ThemeProvider theme={theme}>
          {isCordovaApp ? <CordovaApp /> : <App />}
        </ThemeProvider>
      </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
  );
});

if (!isCordovaApp) {
  document.dispatchEvent(new CustomEvent('deviceready', {}));
}
